//@flow

import s0q1 from './questions/s0-q1.json'
import s1q1 from './questions/s1-q1.json'
import s1q2 from './questions/s1-q2.json'
import s1q2a from './questions/s1-q2a.json'
import s1q3 from './questions/s1-q3.json'
import s1q3a from './questions/s1-q3a.json'
import s1q4 from './questions/s1-q4.json'
import s2q1 from './questions/s2-q1.json'
import s2q2 from './questions/s2-q2.json'
import s2q2a from './questions/s2-q2a.json'
import s2q2b from './questions/s2-q2b.json'
import s2q2c from './questions/s2-q2c.json'
import s2q3 from './questions/s2-q3.json'
import s2q4 from './questions/s2-q4.json'
import s3q1 from './questions/s3-q1.json'
import s3q2 from './questions/s3-q2.json'
import s3q3 from './questions/s3-q3.json'
import s3q4 from './questions/s3-q4.json'
import s4q1 from './questions/s4-q1.json'
import s4q1a from './questions/s4-q1a.json'
import s4q2 from './questions/s4-q2.json'
import s4q3 from './questions/s4-q3.json'
import s5q1 from './questions/s5-q1.json'
import s5q2 from './questions/s5-q2.json'
import s5q3 from './questions/s5-q3.json'
import s5q4 from './questions/s5-q4.json'
import s5q5 from './questions/s5-q5.json'
import s6q1 from './questions/s6-q1.json'
import s6q1a from './questions/s6-q1a.json'
import s6q1b from './questions/s6-q1b.json'
import s6q1c from './questions/s6-q1c.json'
import s6q2 from './questions/s6-q2.json'
import s6q3 from './questions/s6-q3.json'
import s6q4 from './questions/s6-q4.json'
import s6q5 from './questions/s6-q5.json'

export const dlrqQuestions = {
  's0-q1': s0q1,
  's1-q1': s1q1,
  's1-q2': s1q2,
  's1-q2a': s1q2a,
  's1-q3': s1q3,
  's1-q3a': s1q3a,
  's1-q4': s1q4,
  's2-q1': s2q1,
  's2-q2': s2q2,
  's2-q2a': s2q2a,
  's2-q2b': s2q2b,
  's2-q2c': s2q2c,
  's2-q3': s2q3,
  's2-q4': s2q4,
  's3-q1': s3q1,
  's3-q2': s3q2,
  's3-q3': s3q3,
  's3-q4': s3q4,
  's4-q1': s4q1,
  's4-q1a': s4q1a,
  's4-q2': s4q2,
  's4-q3': s4q3,
  's5-q1': s5q1,
  's5-q2': s5q2,
  's5-q3': s5q3,
  's5-q4': s5q4,
  's5-q5': s5q5,
  's6-q1': s6q1,
  's6-q1a': s6q1a,
  's6-q1b': s6q1b,
  's6-q1c': s6q1c,
  's6-q2': s6q2,
  's6-q3': s6q3,
  's6-q4': s6q4,
  's6-q5': s6q5,
}

/// DLRQ Suitability Matrix
/// [Access][Capability]
export const dlrqSuitabilityMatrix = [
  [0, 0, 0, 0, 0, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 1, 1, 1, 1],
  [0, 0, 0, 0, 1, 1, 1, 1, 1],
  [0, 0, 0, 1, 1, 1, 1, 1, 2],
  [0, 0, 1, 1, 2, 2, 2, 2, 2],
  [1, 1, 1, 1, 2, 2, 2, 2, 2],
  [1, 1, 1, 1, 2, 2, 2, 2, 2],
  [1, 1, 1, 1, 2, 2, 2, 2, 2],
  [1, 1, 1, 2, 2, 2, 2, 2, 2]
];



// WEBPACK FOOTER //
// ./src/constants/dlrq/index.js